export const toggleLoginModal = (isOpen) => ({
  type: "TOGGLE_LOGIN_MODAL",
  payload: isOpen,
});

export const toggleSignUpModal = (isOpen) => ({
  type: "TOGGLE_SIGNUP_MODAL",
  payload: isOpen,
});
